import type { SVGProps } from 'react';

const Node = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.6688 10.133C18.3592 10.133 18.9188 9.57335 18.9188 8.883C18.9188 8.19264 18.3592 7.633 17.6688 7.633C16.9785 7.633 16.4188 8.19264 16.4188 8.883C16.4188 9.57335 16.9785 10.133 17.6688 10.133Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.83116 10.133C7.52152 10.133 8.08116 9.57335 8.08116 8.883C8.08116 8.19264 7.52152 7.633 6.83116 7.633C6.14081 7.633 5.58116 8.19264 5.58116 8.883C5.58116 9.57335 6.14081 10.133 6.83116 10.133Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6688 16.3923C18.3592 16.3923 18.9188 15.8326 18.9188 15.1423C18.9188 14.4519 18.3592 13.8923 17.6688 13.8923C16.9785 13.8923 16.4188 14.4519 16.4188 15.1423C16.4188 15.8326 16.9785 16.3923 17.6688 16.3923Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.83116 16.3923C7.52152 16.3923 8.08116 15.8326 8.08116 15.1423C8.08116 14.4519 7.52152 13.8923 6.83116 13.8923C6.14081 13.8923 5.58116 14.4519 5.58116 15.1423C5.58116 15.8326 6.14081 16.3923 6.83116 16.3923Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1982 13.3288C12.8886 13.3288 13.4482 12.7692 13.4482 12.0788C13.4482 11.3885 12.8886 10.8288 12.1982 10.8288C11.5078 10.8288 10.9482 11.3885 10.9482 12.0788C10.9482 12.7692 11.5078 13.3288 12.1982 13.3288Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1983 19.5053C12.8887 19.5053 13.4483 18.9456 13.4483 18.2553C13.4483 17.5649 12.8887 17.0053 12.1983 17.0053C11.508 17.0053 10.9483 17.5649 10.9483 18.2553C10.9483 18.9456 11.508 19.5053 12.1983 19.5053Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1983 6.99472C12.8887 6.99472 13.4483 6.43508 13.4483 5.74472C13.4483 5.05436 12.8887 4.49472 12.1983 4.49472C11.508 4.49472 10.9483 5.05436 10.9483 5.74472C10.9483 6.43508 11.508 6.99472 12.1983 6.99472Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="10.8356"
      y1="17.7233"
      x2="7.40345"
      y2="15.4549"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="11.4942"
      y1="12.5842"
      x2="7.93135"
      y2="14.6412"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="4.114"
      y2="-0.75"
      transform="matrix(-0.866025 -0.5 -0.5 0.866025 11.1192 12.0788)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="4.114"
      y2="-0.75"
      transform="matrix(0.866025 0.5 0.5 -0.866025 13.9865 11.9347)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="13.0867"
      y1="11.7255"
      x2="16.6495"
      y2="9.66854"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(-0.865159 0.501498 0.501498 0.865159 11.2491 6.86642)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 7.55635 10.0213)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 12.9706 13.1151)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 12.9297 6.87183)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(0.865159 -0.501498 -0.501498 -0.865159 13.1293 17.0976)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      x1="13.5054"
      y1="6.21756"
      x2="16.6332"
      y2="8.03063"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <line
      y1="-0.75"
      x2="3.61531"
      y2="-0.75"
      transform="matrix(-4.37114e-08 1 1 4.37114e-08 18.4267 10.0213)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default Node;
